import Utils from "./Utils"
import * as CryptoJS from "../Lib/crypto-js"

const CashePath = cc.sys.isNative ? jsb.fileUtils.getWritablePath() + "ImageCache/" : ""

class ImageCache {
    private _downloadFailedImages = []

    /**
     * 加载缓存资源
     * @param url 远程路径
     * @param callback 回调函数
     */
    loadImage (url: string, callback: Function) {
        if (!cc.sys.isNative) {
            cc.log("该方法只支持原生平台")
            return
        }
        
        let path = this.getCachePath(url)
        
        if (jsb.fileUtils.isFileExist(path)) {
            this.load(path, callback)
        }
        
        !jsb.fileUtils.isDirectoryExist(CashePath) && jsb.fileUtils.createDirectory(CashePath)
        this.downloadImage(url, path, callback)
    }

    /**
     * 获取缓存路径
     * @param url 远程路径
     */
    getCachePath (url: string) {
        let name = url.substring(0, url.lastIndexOf("."))
        let suffix = url.substring(url.lastIndexOf("."))
        let path = CashePath + CryptoJS.MD5(name) + suffix
        return path
    }

    /**
     * 删除缓存目录
     */
    removeCasheDirectory () {
        if (!cc.sys.isNative) {
            cc.log("该方法只支持原生平台")
            return
        }
        jsb.fileUtils.isDirectoryExist(CashePath) && jsb.fileUtils.removeDirectory(CashePath)
    }

    /**
     * 重新下载之前下载失败的图片
     */
    downloadFailedImages () {
        if (this._downloadFailedImages.length === 0) return
        this._downloadFailedImages.forEach(item => {
            this.downloadImage(item.url, item.path, item.callback)
        });
        this._downloadFailedImages = []
    }

    private load (path: string, callback: Function) {
        cc.loader.load(path, function (err, texture) {
            callback(err, texture)
        }.bind(this))
    }

    private downloadImage (url, path, callback) {
        Utils.saveUrlFile2(url, path, function (data) {
            // 解决部分安卓记断网再开网，图片加载不出来的问题。延迟一下
            setTimeout(function () {
                this.load(data, callback)
            }.bind(this), 200)
        }.bind(this), function () {
            this._downloadFailedImages.push({url: url, path: path, callback: callback})
        }.bind(this))
    }
}

export default new ImageCache()